import React from 'react';

export default function PromptConfirmDeleteQueue({ show, setViewMode, doAppointmentQueueDelete }) {

    if (show) {

        return (
            <div className="modal fade show" id="confirmDeleteQueueModal" aria-modal="true" role="dialog" style={{ display: "block" }} >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <h2>Proceed with the appointment cancellation?</h2>
                            <p>This action cannot be undone</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light" onClick={() => setViewMode('')}> No </button>
                            <button type="button" className="btn btn-primary" onClick={() => doAppointmentQueueDelete()}> Yes </button>
                        </div>
                    </div>
                </div>
            </div>
        );

    } else { return null; }

}